const ComplementoPlanesDeRetiroRules = ( data = {} ) => {
  let rule = 'numeric';
  let MontTotRetiradoAnioInmAntPerRule = 'numeric';

  const {
    MontTotRetiradoAnioInmAntPer
  } = data;

  if (!!MontTotRetiradoAnioInmAntPer) {
    rule = 'required';
  }

  return {
    SistemaFinanc: [
      'required',
      'string',
      'in:SI,NO',
    ],
    MontTotAportAnioInmAnterior: [
      'decimal:6',
    ],
    MontIntRealesDevengAniooInmAnt: [
      'required',
      'decimal:6',
    ],
    HuboRetirosAnioInmAntPer: [
      'required',
      'string',
      'in:SI,NO',
    ],
    MontTotRetiradoAnioInmAntPer: [
      MontTotRetiradoAnioInmAntPerRule,
      'decimal:6',
    ],
    MontTotExentRetiradoAnioInmAnt: [
      rule,
      'decimal:6',
    ],
    MontTotExedenteAnioInmAnt: [
      rule,
      'decimal:6',
    ],
    HuboRetirosAnioInmAnt: [
      'required',
      'string',
      'in:SI,NO',
    ],
    MontTotRetiradoAnioInmAnt: [
      'decimal:6',
    ],
    NumReferencia: [
      'string',
      'min:1',
      'max:300',
    ]
  }
};

export default ComplementoPlanesDeRetiroRules;
